import React from 'react';

import Show from 'components/Show';
import { Title } from 'components/Misc/Typography';
import { Button, Input } from 'components/Misc/Form';

import { useTaskCreateStore } from 'store/task/useTaskCreateStore';

const Generator = () => {
	// Use task's create store
	const [type, generator, onChangeGenerator, onInitGenerator ] = useTaskCreateStore(state => [
		state.task.type,
		state.generator,
		state.onChangeGenerator,
		state.onInitGenerator
	]);

	return (
		<>
			<Title
				title="Uzdevuma ģenerators"
				className="col-span-2 text-xl"
			/>

			<div className="col-span-2 flex items-end gap-4">
				<Input
					type="number"
					name="questions"
					label="Jautājumu skaits"
					value={generator.questions}
					onChange={onChangeGenerator}
					className="flex-1"
				/>

				<Show if={type === 'quiz'}>
					<Input
						type="number"
						name="options"
						label="Atbilžu skaits"
						value={generator.options}
						onChange={onChangeGenerator}
						className="flex-1"
					/>
				</Show>

				<Button
					value="Ģenerēt"
					icon="dynamic_feed"
					onClick={onInitGenerator}
				/>
			</div>
		</>
	);
};

export default Generator;